import {Box} from '@mui/material';
import React from 'react';
import ArrCodingFormEditor, {
  CodingFormType,
} from '../../../components/common/arr-codingform-editor/ArrCodingFormEditor';

const tempArray = {
  id: 0,
  cfItemID: 0,
  type: CodingFormType.TAG,
  specialFlag: false,
  value: '1',
  systemLabel: 'TAG_1',
  friendlyLabel: 'Sample Tag',
  logicRuleCount: '0',
  tagType: '',
  errorMessage: '',
  defaultAction: '',
  helpText: '',
  fieldLogic: [],
  fieldLogicJson: '',
  fieldLogicAction: '',
  fieldLogicObjectLabel: `Sample Tag (TAG_1)`,
  groupAssociation: '',
  metaDataType: 'null',
  maxLength: 0,
  minValue: 'null',
  maxValue: 'null',
  splitLength: 0,
  dataTypeLengthCode: '',
} as any;

const defaultObjects = [
  {...tempArray},
  {
    id: 1,
    cfItemID: 1,
    type: CodingFormType.FIELD,
    specialFlag: false,
    value: '2',
    systemLabel: 'FIELD_2',
    friendlyLabel: 'Sample Tag',
    logicRuleCount: '0',
    tagType: '',
    errorMessage: '',
    defaultAction: '',
    helpText: '',
    fieldLogic: [],
    fieldLogicJson: '',
    fieldLogicAction: '',
    fieldLogicObjectLabel: `Sample Tag (TAG_1)`,
    groupAssociation: '',
    metaDataType: 'null',
    maxLength: 0,
    minValue: 'null',
    maxValue: 'null',
    splitLength: 0,
    dataTypeLengthCode: '',
  },
  {
    id: 2,
    cfItemID: 2,
    type: CodingFormType.RADIOGROUP,
    specialFlag: false,
    value: '2',
    systemLabel: 'RADIOGROUP_1',
    friendlyLabel: 'Sample Tag',
    logicRuleCount: '0',
    tagType: '',
    errorMessage: '',
    defaultAction: '',
    helpText: '',
    fieldLogic: [],
    fieldLogicJson: '',
    fieldLogicAction: '',
    fieldLogicObjectLabel: `Sample Tag (TAG_1)`,
    groupAssociation: '',
    metaDataType: 'null',
    maxLength: 0,
    minValue: 'null',
    maxValue: 'null',
    splitLength: 0,
    dataTypeLengthCode: '',
  },
  {
    id: 3,
    cfItemID: 3,
    type: CodingFormType.CHECKGROUP,
    specialFlag: false,
    value: '3',
    systemLabel: 'CHECKGROUP_2',
    friendlyLabel: 'Sample Tag',
    logicRuleCount: '0',
    tagType: '',
    errorMessage: '',
    defaultAction: '',
    helpText: '',
    fieldLogic: [],
    fieldLogicJson: '',
    fieldLogicAction: '',
    fieldLogicObjectLabel: `Sample Tag (TAG_1)`,
    groupAssociation: '',
    metaDataType: 'null',
    maxLength: 0,
    minValue: 'null',
    maxValue: 'null',
    splitLength: 0,
    dataTypeLengthCode: '',
  },
] as any;

const CodingFormEditorDemo = () => {
  return (
    <Box className="demo-page coding-form-editor-demo-main">
      <Box className="coding-form-editor-demo">
        <Box>
          <h2>Tag Type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={tempArray}
            codingFormObjects={defaultObjects}
          />
        </Box>
        <Box>
          <h2>Comment Type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={{...tempArray, type: CodingFormType.COMMENT}}
            codingFormObjects={defaultObjects}
          />
        </Box>
      </Box>
      <Box className="coding-form-editor-demo">
        <Box>
          <h2>Field type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={{...tempArray, type: CodingFormType.FIELD}}
            codingFormObjects={defaultObjects}
          />
        </Box>
        <Box>
          <h2>Statictext Type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={{...tempArray, type: CodingFormType.STATICTEXT}}
            codingFormObjects={defaultObjects}
          />
        </Box>
      </Box>
      <Box className="coding-form-editor-demo">
        <Box>
          <h2>Radio Group Type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={{...tempArray, type: CodingFormType.RADIOGROUP}}
            codingFormObjects={defaultObjects}
          />
        </Box>
        <Box>
          <h2>Checkbox Type Editor</h2>
          <ArrCodingFormEditor
            codingFormData={{...tempArray, type: CodingFormType.CHECKGROUP}}
            codingFormObjects={defaultObjects}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CodingFormEditorDemo;
